import { makeStylesPropulsion } from '@ui-propulsion/react-components';

const styles = theme => {
  const {
    typography: { body1, micro, hero, fontFamilyBold },
    palette,
  } = theme;

  return {
    root: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: '6px',
      maxWidth: '360px',
      '@media (min-width: 769px)': {
        maxWidth: '425px',
        gap: '12px',
      },
      '@media (min-width: 1024px)': {
        maxWidth: '490px',
        gap: '16px',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    title: {
      ...body1,
      fontFamily: fontFamilyBold,
      color: palette.denim[500],
      textAlign: 'center',
    },
    amount: {
      ...hero,
      fontFamily: fontFamilyBold,
      color: palette.denim[500],
      textAlign: 'center',
    },
    desc: {
      ...micro,
      color: palette.denim[300],
      marginTop: '4px',
      textAlign: 'center',
    },
    circleIcon: {
      border: '1px solid',
      borderColor: palette.stainless[500],
      boxShadow: '0 1px 6px rgba(0, 0, 0, 0.2)',
      borderRadius: ' 25px',
      cursor: 'pointer',
      width: '30px',
      height: '30px',
      backgroundRepeat: ' no-repeat',
      backgroundPosition: 'center',
      transition: 'all 0.5s ease',
      '@media (min-width: 769px)': {
        width: '35px',
        height: '35px',
      },
      '@media (min-width: 1024px)': {
        width: '40px',
        height: '40px',
      },

      '&:focus, &:hover': {
        outline: 'none',
        borderColor: palette.sky[900],
      },
    },
    circleIconDisabled: {
      transition: 'all 0.5s ease',
      boxShadow: 'none',
      cursor: 'default',
      '&:focus, &:hover': {
        borderColor: palette.stainless[500],
      },
    },
  };
};

export const useStyles = makeStylesPropulsion(styles, { name: 'BauiLoanAmountFilter' });

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/LoanAmountFilter.scss');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-sky-900.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-stainless-500.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-sky-900.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-stainless-500.svg');